var yearSeatRow;
var yearSeatShifting;
$(document).on('keyup keydown', function(e){yearSeatShifting = e.shiftKey;});

function yearSeatsCollection() {
    // if ($('.year-seats-table tbody tr.selected').length) {
    //     $('.year-seats-collector').addClass('visible');

    //     // get the data from each of the rows
    //     $('.year-seats-collector [data-input="count"]').html($('.year-seats-table tbody tr.selected').length);

        
    //     var total_violators = 0;
    //     var total_payments = 0;
    //     var total_paid = 0;
    //     $('.year-seats-table tbody tr.selected').each(function () {
    //         var yeatSeat = $(this);

    //         // set the violators
    //         if (yeatSeat.attr('data-violators')) {
    //             total_violators++;
    //         }

    //         // set the payments
    //         total_payments += parseInt(yeatSeat.attr('data-total_payments'));

    //         // set the paid
    //         total_paid += (isNaN(parseFloat(yeatSeat.attr('data-total_paid'))) ? 0 : parseFloat(yeatSeat.attr('data-total_paid')))
    //     });
        
    //     $('.year-seats-collector [data-input="total_violators"]').html(total_violators);
    //     $('.year-seats-collector [data-input="total_payments"]').html(total_payments);
    //     $('.year-seats-collector [data-input="total_paid"]').html(`$${total_paid.toFixed(2)}`);

    //     return false;
    // }

    // $('.year-seats-collector').removeClass('visible');
}

$('body').on('click', '.select-year-seat-trigger', function() {
    var $this = $(this);
    var oldRow = yearSeatRow;
    var i;

    yearSeatRow = $('.year-seats-table tbody tr').index($this.parents('tr'));
    $this.parents('tr').toggleClass('selected');

    // if we have a shifted row we need to select all
    if(yearSeatShifting && yearSeatRow >= 0) {
        if(yearSeatRow > oldRow) {
            // shift down
            for(i = oldRow+1; i < yearSeatRow; i++) {
                $('.year-seats-table tbody tr').eq(i).toggleClass('selected').blur();
            }
        } else {
            // shift up
            for(i = oldRow-1; i > yearSeatRow; i--) {
                $('.year-seats-table tbody tr').eq(i).toggleClass('selected').blur();
            }
        }
    }

    yearSeatsCollection();

    if (window.getSelection) {
        if (window.getSelection().empty) {  // Chrome
            window.getSelection().empty();
        } else if (window.getSelection().removeAllRanges) {  // Firefox
            window.getSelection().removeAllRanges();
        }
    } else if (document.selection) {  // IE?
        document.selection.empty();
    }
    
    return false;
});

$('body').on('click', '.select-all-year-seats-trigger', function() {
    var $this = $(this);

    if($this.hasClass('active')) {
        $this.removeClass('active');
        $('.year-seats-table tbody tr').removeClass('selected');
    } else {
        $this.addClass('active');
        $('.year-seats-table tbody tr').addClass('selected');
    }

    yearSeatsCollection();
    
    return false;
});

$('body').on('click', '.year-seats .filters .open-dropdown', function () {
    var $this = $(this);
    var menu = $this.parents('.dropdown-wrapper');

    if (menu.hasClass('opened')) {
        closeDropdown();
        return false;
    }

    menu.addClass('opened');
    closeDropdown($this.parents('.dropdown-wrapper').attr('data-dropdown'));
    return false;
});

$("body").on("click", ".open-year-seat-menu", function () {
    var $this = $(this);
    var menu = $this.parents(".year-seat-menu-wrapper");

    $(".year-seat-menu", menu).css({
        top: menu.position().top,
        left:
            5 + (menu.position().left + menu.width()) - $(".year-seat-menu", menu).width()
    });

    menu.addClass("opened");
    closeDropdown($this.parents(".year-seat-menu-wrapper").attr("data-dropdown"));
    return false;
});

$('body').on('click', '.edit-year-seat-trigger', function() {
    var data = $(this).parents('.year-seat');
    var action = $('.edit-year-seat form').attr('data-action').replace('{year_seat}', data.attr('data-year_seat'));
    $('.edit-year-seat form').attr('action', action);

    $('.edit-year-seat [name="name"]').val(data.attr('data-name'));
    $('.edit-year-seat [name="hebrew_name"]').val(data.attr('data-hebrew_name'));
    $('.edit-year-seat [name="cost"]').val(data.attr('data-cost'));
    $('.edit-year-seat [name="due_date"]').val(data.attr('data-due_date'));
    $('.edit-year-seat input[name="paid"]').prop('checked', data.attr('data-paid') === 'true' ? true : false);

    openModal('.edit-year-seat');
    closeDropdown();
    return false;
});

$('body').on('submit', '.edit-year-seat form', function() {
    var $this = $(this);
    var modal = $this.parents('.modal');
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };
    
    var error = false;

    modal.find('.required').each(function() {
        if($(this).val() === '') {
            error = true;
        }
    });

    if(error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }
    
    loading();
    $.ajax({
        type : 'POST',
        url : $this.attr('action'),
        data : fields,
        dataType : 'json',
        success : function(data) {
            console.log(data);
            unloading();

            if(!data.success) {
                showError('Error', data.message);
                return false;
            }

            closeModal();
            addNotification(data.notification.title, data.notification.message, data.notification.icon);
        },
        error : function(request) {
            console.log(request.responseText);
        }
    });

    return false;
});

$('body').on('click', '.year-seat .create-year-seat-owner-trigger', function () {
    var $this = $(this);
    $this.parents('.year-seat').addClass('selected');

    // append all the selected cards to the form
    $('.add-owner input[name="year_seats[]"]').remove();
    $('.year-seats-table tbody tr.selected').each(function () {
        $('.add-owner form').append($('<input>', {
            name: 'year_seats[]',
            value: $(this).attr('data-year_seat'),
            type: 'hidden'
        }));
    });

    openModal('.add-owner');
    closeDropdown();
    return false;
});

$('body').on('click', '.year-seat .change-year-seat-owner-trigger', function () {
    var $this = $(this);
    $this.parents('.year-seat').addClass('selected');

    // append all the selected cards to the form
    $('.change-year-seat-owner input[name="year_seats[]"]').remove();
    $('.change-year-seat-owner input[name="owner"]').val('');
    $('.year-seats-table tbody tr.selected').each(function () {
        $('.change-year-seat-owner form').append($('<input>', {
            name: 'year_seats[]',
            value: $(this).attr('data-year_seat'),
            type: 'hidden'
        }));
    });

    openModal('.change-year-seat-owner');
    closeDropdown();
    return false;
});



$('body').on('keyup', '.change-year-seat-owner .selector input', function(e) {
    var $this = $(this);
    var selector = $this.parents('.selector');

    var navigationKeys = [40, 38, 13];
    if(navigationKeys.indexOf(e.keyCode) !== -1) {
    	return false;
    }

    if($this.val().length < 3) {
    	$('.change-year-seat-owner .selector .selector-results ul').html('');
    	$('.change-year-seat-owner .selector .selector-results').addClass('hidden');
    	return false;
    }

    $.ajax({
		type : 'POST',
		url : selector.attr('data-url'),
		data : {
			'search': $this.val(),
			'_token': $('meta[name="csrf-token"]').attr('content'),
			'_method': 'GET'
		},
		dataType : 'json',
		success : function(data) {
			console.log(data);
			$('.change-year-seat-owner .selector .selector-results ul').html('');
			if(!data.success) {
				$('.change-year-seat-owner .selector .selector-results').addClass('hidden');
				return false;
			}

			$('.change-year-seat-owner .selector .selector-results').removeClass('hidden');
			$.each(data.owners, function(index, owner) {
				$('.change-year-seat-owner .selector ul').append(`<li>
				<a href="#"
				class="select-existing-owner"
                data-owner="${owner.owner}"
                data-name="${owner.name ? owner.name : ''}"
                data-hebrew_name="${owner.hebrew_name ? owner.hebrew_name : ''}"
                data-street="${owner.street ? owner.street : ''}"
                data-apt="${owner.apt ? owner.apt : ''}"
                data-city="${owner.city ? owner.city : ''}"
                data-state="${owner.state ? owner.state : ''}"
                data-zip="${owner.zip ? owner.zip : ''}"
                data-email="${owner.email ? owner.email : ''}"
                data-phone="${owner.phone ? owner.phone : ''}"
				>
                    ${owner.name} - ${owner.hebrew_name} <br>
                    ${owner.phone ? owner.phone : ''} ${
                    owner.email ? owner.email : ''
                }
				</a>
			</li>`);
			});
		},
		error : function(request) {
			console.log(request.responseText);
		}
	});
    
    return false;
});

$('body').on('focus', '.change-year-seat-owner .selector input', function() {
	closeDropdown($('.change-year-seat-owner .selector .selector-results').attr('data-dropdown'));
    if($('.change-year-seat-owner .selector .selector-results ul li').length) {
    	$('.change-year-seat-owner .selector .selector-results').removeClass('hidden');
    }
    return false;
});

$('body').on('keydown', '.change-year-seat-owner .selector input', function(e) {
	var scrollTop = $('.change-year-seat-owner .selector .selector-results ul').scrollTop();
	// console.log(scrollTop);
	var element = null;

	// down arrow
    if(e.keyCode === 40) {
		if(!$('.change-year-seat-owner .selector .selector-results ul li').length) {
			return false;
		}

		// if we dont have any selected
		if(!$('.change-year-seat-owner .selector .selector-results ul li.selected').length) {
	    	$('.change-year-seat-owner .selector .selector-results ul li').each(function() {
	    		var $this = $(this);
	    		if(($this.position().top + $this.height()) >= 0) {
	    			element = $this;
	    			return false;
	    		}
	    	});

	    	$('.change-year-seat-owner .selector .selector-results ul li').removeClass('selected');
	    	element.addClass('selected');
	    	$('.change-year-seat-owner .selector .selector-results ul').scrollTop(element.position().top + scrollTop);
	    	return false;
		}

		// if we have a next
		if($('.change-year-seat-owner .selector .selector-results ul li.selected').next().length) {
			element = $('.change-year-seat-owner .selector .selector-results ul li.selected').next();
			
			$('.change-year-seat-owner .selector .selector-results ul li').removeClass('selected');
			element.addClass('selected');
			$('.change-year-seat-owner .selector .selector-results ul').scrollTop(element.position().top + scrollTop);
			return false;
		}
		return false;
    }


    // up arrow
    if(e.keyCode === 38) {
    	if(!$('.change-year-seat-owner .selector .selector-results ul li.selected').length) {
    		return false;
    	}

    	// if we have a previous
    	if($('.change-year-seat-owner .selector .selector-results ul li.selected').prev().length) {
    		element = $('.change-year-seat-owner .selector .selector-results ul li.selected').prev();
    		
    		$('.change-year-seat-owner .selector .selector-results ul li').removeClass('selected');
			element.addClass('selected');
			$('.change-year-seat-owner .selector .selector-results ul').scrollTop(element.position().top + scrollTop);
			return false;
    	}
    }

    // enter arrow
    if(e.keyCode === 13) {
    	if(!$('.change-year-seat-owner .selector .selector-results ul li.selected').length) {
			return false;
		}

		element = $('.change-year-seat-owner .selector .selector-results ul li.selected');
		element.find('a').trigger('click');

		return false;
    }
});

$('body').on('click', '.change-year-seat-owner .select-existing-owner', function() {
    var $this = $(this);
    
    
    $('.change-year-seat-owner [name="name"]').val($this.attr('data-name'));
    $('.change-year-seat-owner [name="hebrew_name"]').val($this.attr('data-hebrew_name'));
    $('.change-year-seat-owner [name="street"]').val($this.attr('data-street'));
    $('.change-year-seat-owner [name="apt"]').val($this.attr('data-apt'));
    $('.change-year-seat-owner [name="city"]').val($this.attr('data-city'));
    $('.change-year-seat-owner [name="state"]').val($this.attr('data-state'));
    $('.change-year-seat-owner [name="zip"]').val($this.attr('data-zip'));
    $('.change-year-seat-owner [name="email"]').val($this.attr('data-email'));
    $('.change-year-seat-owner [name="phone"]').val($this.attr('data-phone'));
    $('.change-year-seat-owner [name="owner"]').val($this.attr('data-owner'));
    openModal('.change-year-seat-owner');
	closeDropdown();
    return false;
});

$('body').on('submit', '.change-year-seat-owner form', function() {
    var $this = $(this);
    var modal = $this.parents('.modal');
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };
    
    var error = false;

    modal.find('.required').each(function() {
        if($(this).val() === '') {
            error = true;
        }
    });

    if(error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }
    
    loading();
    $.ajax({
        type : 'POST',
        url : $this.attr('action'),
        data : fields,
        dataType : 'json',
        success : function(data) {
            console.log(data);
            unloading();

            if(!data.success) {
                showError('Error', data.message);
                return false;
            }

            closeModal();
            addNotification(data.notification.title, data.notification.message, data.notification.icon);
        },
        error : function(request) {
            console.log(request.responseText);
        }
    });

    return false;
});


channel.bind('process-year-seat', function(data) {
    // console.log(data);
    var element;

    if($('.year-seat[data-year_seat="'+data.year_seat+'"]').length) {
        element = $('.year-seat[data-year_seat="'+data.year_seat+'"]');

        element.attr('data-owner', data.owner);
        element.attr('data-seat', data.seat);
        element.attr('data-status', data.status);
        element.attr('data-name', data.name);
        element.attr('data-hebrew_name', data.hebrew_name);
        element.attr('data-cost', data.cost);
        element.attr('data-paid', data.paid);
        element.attr('data-due_date', data.due_date);

        element.find('[data-input="seat_seat_number"]').html(data.seat_seat_number);
        element.find('[data-input="seat_old_number"]').html(data.seat_old_number);
        element.find('[data-input="seat_name"]').html(data.seat_name);
        element.find('[data-input="seat_hebrew_name"]').html(data.seat_hebrew_name);
        element.find('[data-input="name"]').html(data.name);
        element.find('[data-input="hebrew_name"]').html(data.hebrew_name);
        element.find('[data-input="status"]').html(data.status);
        element.find('[data-input="status"]').attr('data-color', data.status_color);
        element.find('[data-input="total_payments"]').html(data.total_payments);
        element.find('[data-input="total_paid_parsed"]').html(data.total_paid_parsed);
        element.find('[data-input="total_upcoming_payments"]').html(data.total_upcoming_payments);
        element.find('[data-input="total_upcoming_paid_parsed"]').html(data.total_upcoming_paid_parsed);
        element.find('[data-input="cost_parsed"]').html(data.cost_parsed);
        element.find('[data-input="due_date_parsed"]').html(data.due_date_parsed);
        element.find('[data-input="seat_notes"]').html(data.seat_notes);

        element.find('[data-input="owner_total_payments"]').html(data.owner_total_payments);
        element.find('[data-input="owner_total_paid_parsed"]').html(data.owner_total_paid_parsed);
        element.find('[data-input="owner_total_upcoming_payments"]').html(data.owner_total_upcoming_payments);
        element.find('[data-input="owner_total_upcoming_paid_parsed"]').html(data.owner_total_upcoming_paid_parsed);
        element.find('[data-input="owner_total_seats"]').html(data.owner_total_seats);
        element.find('[data-input="owner_total_seat_cost_parsed"]').html(data.owner_total_seat_cost_parsed);

        element.find('.menu').html(buttons(data.buttons));
        return;
    }
});